export default {
  'notifications.list.createNotifications': 'Create Notification',
  'notifications.table.title': 'Title',
  'notifications.table.message': 'Message',
  'notifications.table.dateAndTime': 'Date and Time',
  'notifications.table.actions': 'Actions',
  'notifications.table.actions.markAsRead': 'Mark as read',

  'notifications.markAsRead.title':
    'Do you really want to mark this notification as read?',
  'notifications.markAsRead.description':
    'When marking as read, it will not be possible to revert',

  'notifications.success.title': 'Success!',
  'notifications.success.description': 'Notification marked as read',

  'notifications.form.date': 'Date',
  'notifications.form.message': 'Message',
  'notifications.form.title': 'Title',
  'notifications.form.users': 'Users',
  'notifications.form.groupUsers': 'User Group',

  'notification.workOrders.lgpd.change.title': 'Saved successfully!.',
  'notification.workOrders.lgpd.change.description':
    'The GDPR Term can be customized in company settings.',
  'notification.workOrders.lgpd.information':
    'The GDPR reminder and consent settings can be changed in the customers tab.',
};
